import { Link } from "react-router-dom";

const Pagination = ({ totalItems, itemsPerPage, currentPage, paginate }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  return (
    <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
      <div className="dataTables_info">
        Showing {totalItems > 0 ? indexOfFirstItem + 1 : 0} to{" "}
        {indexOfLastItem > totalItems ? totalItems : indexOfLastItem} of{" "}
        {totalItems} results
      </div>
      <div
        className="dataTables_paginate paging_simple_numbers premium-pagination"
        id="example5_paginate"
      >
        <Link
          className={`paginate_button previous ${currentPage === 1 ? "disabled" : ""}`}
          to="#"
          onClick={() => currentPage > 1 && paginate(currentPage - 1)}
        >
          Previous
        </Link>
        <span>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((number) => (
            <Link
              key={number}
              to="#"
              className={`paginate_button ${currentPage === number ? "current" : ""}`}
              onClick={() => paginate(number)}
            >
              {number}
            </Link>
          ))}
        </span>
        <Link
          className={`paginate_button next ${currentPage === totalPages || totalPages === 0 ? "disabled" : ""}`}
          to="#"
          onClick={() => currentPage < totalPages && paginate(currentPage + 1)}
        >
          Next
        </Link>
      </div>
    </div>
  );
};

export default Pagination;
